
import ControllerBase from '../../../../global/js/ControllerBase';

export default class ControllerImageGalleryModal extends ControllerBase {

	constructor(element: HTMLElement) {
		super(element);
		this.init();
	}

	private init(): void {

		const imageRenderer = document.querySelector('#m-image-gallery-modal-image') as HTMLElement;
		const mediaCenterModalBG = document.querySelector('#m-image-gallery-modal-bg') as HTMLElement;
		const closeButton = document.querySelector('#m-image-gallery-modal-close') as HTMLElement;

		this.$element.addEventListener('click', e => {
			const et = e.target as HTMLElement;
			if (et.parentElement && et.parentElement.classList.contains('m-image-gallery-slide')) {
				const image = et.parentElement?.getAttribute('data-href') as string;
				if (imageRenderer) {
					imageRenderer.setAttribute('src', image);
					mediaCenterModalBG.classList.add('opened');
				}
			}
		});

		closeButton.addEventListener('click', () => {
			if (mediaCenterModalBG) mediaCenterModalBG.classList.remove('opened');
			imageRenderer.setAttribute('src', '');
		});

		mediaCenterModalBG.addEventListener('click', () => {
			if (mediaCenterModalBG) mediaCenterModalBG.classList.remove('opened');
			imageRenderer.setAttribute('src', '');
		});


	}
}
